import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { config } from './config.js'

import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

console.log(config, window.location)

ReactDOM.render(
    <div>
        <BrowserRouter basename={`${config.build_root}`}>
            <App />
        </BrowserRouter>
    </div>,
    document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js